import { z } from 'zod';

export const ANNOUNCEMENT_CRITERIA_VALUES = ['error', 'warning', 'information'] as const;
export type AnnouncementCriteria = (typeof ANNOUNCEMENT_CRITERIA_VALUES)[number];

export const AnnouncementSchema = z.object({
  id: z.string().uuid(),
  tenantId: z.string().uuid(),
  criteria: z.enum(ANNOUNCEMENT_CRITERIA_VALUES),
  heading: z.string(),
  subheading: z.string().nullable(),
  explanation: z.string().nullable(),
  isPublished: z.boolean(),
  startAt: z.string(),
  endAt: z.string().nullable(),
  active: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type Announcement = z.infer<typeof AnnouncementSchema>;

const AnnouncementBody = z.object({
  criteria: z.enum(ANNOUNCEMENT_CRITERIA_VALUES),
  heading: z.string().min(1).max(200),
  subheading: z.string().max(300).nullable().optional(),
  explanation: z.string().max(10000).nullable().optional(),
  isPublished: z.boolean().optional(),
  startAt: z.string(),
  endAt: z.string().nullable().optional(),
});

export const CreateAnnouncementInput = AnnouncementBody;
export type CreateAnnouncementInput = z.infer<typeof CreateAnnouncementInput>;

export const PatchAnnouncementInput = AnnouncementBody.partial();
export type PatchAnnouncementInput = z.infer<typeof PatchAnnouncementInput>;

export interface ListAnnouncementsQuery {
  q?: string;
  criteria?: AnnouncementCriteria;
  isPublished?: boolean;
  active?: boolean;
  sortField?: 'heading' | 'startAt' | 'endAt' | 'createdAt' | 'updatedAt';
  sortDirection?: 'asc' | 'desc';
  limit?: number;
  offset?: number;
}
